import { IconsProps } from './IconsProps';

const Minus = ({
  className = '',
  viewBox = '0 0 24 24',
  width = 24,
  height = 24,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path d="M4.465 12.125h15.07c.16 0 .31-.068.42-.186a.644.644 0 0 0 .17-.439c0-.163-.06-.32-.17-.439a.574.574 0 0 0-.42-.186H4.465c-.16 0-.31.068-.42.186a.645.645 0 0 0-.17.439c0 .163.06.32.17.439.11.118.26.186.42.186Z" />
    </svg>
  );
};

export default Minus;
